import React, { ChangeEvent, useState } from 'react';
import { TbMessage2Question } from 'react-icons/tb';

interface AddProductObservationProps {
    onHandleObservation: CallableFunction;
}

const AddProductObservation = ({
    onHandleObservation
}: AddProductObservationProps) => {

    const [newObservation, setNewObservation] = useState<any>('');

    const handleNewObservation = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setNewObservation(event.target.value)
        onHandleObservation(event)
    };

    return (
        <div className="flex flex-col gap-1 w-full">
            <h4 className='flex items-center gap-0.5 font-medium text-sm text-custom-primary'>
                <TbMessage2Question />
                <span>Alguma observação?</span>
            </h4>
            <textarea
                // id="observation"
                name="observation"
                className={`
                block w-full rounded-md text-sm border-0 p-2.5 shadow ring-1 ring-gray-300 placeholder:text-gray-300 
                focus:ring-2 focus:ring-custom-primary
                transition-all ease-in-out duration-500
                ${newObservation ? 'h-24' : 'h-16'}
                focus:h-24
                `}
                placeholder='Ex: Tirar cebola, maionese à parte, ponto da carne etc'
                defaultValue={''}
                onChange={(event) => handleNewObservation(event) }
            />
        </div>
    )
}

export default AddProductObservation;
